import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '../Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Back from '../../../components/common/Back';
import { fetchEnquiriesList } from '../../../redux/slices/admin/enquiriesSlice';
import { exportClients } from '../../../redux/slices/admin/clientsSlice';
import EnquiriesTable from './EnquiriesTable';
import SearchField from '../../../components/common/SearchField';
import iconDownload from '../../../images/icon-download.svg';

const Enquiries = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('enquiries_list');

  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    dispatch(fetchEnquiriesList({ page: 1, searchTerm:searchTerm }));
  }, []);

  const handlePageChange = (page) => {
    dispatch(fetchEnquiriesList({ page: 1, searchTerm:searchTerm }));
  }

  const handleSearch = (searchTerm, activeTab) => {
    dispatch(fetchEnquiriesList({ page: 1, searchTerm:searchTerm }));
  }

  const handleDownloadExcel = (type) => {
    dispatch(exportClients(type));
  };

  return (
    <Layout>
      <div className="container-xxl">
        <div className="row mx-0 p-3 g-3 p-md-4 nav-users-tab">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Enquiries</h1>
            <div className="ms-auto">
               <Back />
            </div>
          </header>
          <div className="col">
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'enquiries_list' ? 'active' : ''}`}
                  type="button"
                  role="tab"
                >
                  Enquiries List
                </button>
              </li>
            </ul>
          </div>

         <div className="col-12 mt-4">
      <div className="tab-content">
        {activeTab === 'enquiries_list' && (
          <div className="tab-pane show active" role="tabpanel">
            <ul className="ul-btns-action" style={{position:'absolute', top:'-85px'}}>
                   <li>
                <a onClick={()=>handleDownloadExcel('enquiriesList')}  style={{marginTop:'-5px'}}>
                  <img src={iconDownload} alt="Download" />
                </a>
              </li>
            </ul>
            <SearchField handleSearch={handleSearch} activeTab={activeTab} placeholder="Search..." />
            <EnquiriesTable handlePageChange={(page) => dispatch(fetchEnquiriesList({ page }))}
            />
          </div>
        )}       
      </div>
    </div>
        </div>  
      </div>
    </Layout>
  );
};

export default Enquiries;